import { addAfterEffect } from '@react-three/fiber'
import * as THREE from 'three'
import { OrthographicCamera } from 'three'
import { FadeInProps } from '../types'

const fadeIn = async ({ camera, scene, duration = 500, color = 0x000000 }: FadeInProps) => {
  return new Promise(res => {
    const geo = new THREE.PlaneGeometry(100, 100)
    const mat = new THREE.MeshBasicMaterial({ color, transparent: true, opacity: 1 })
    const overlay = new THREE.Mesh(geo, mat)
    const cam = camera as OrthographicCamera
    overlay.rotation.setFromRotationMatrix(cam.matrix)
    overlay.position.z = cam.position.z - cam.near
    scene.add(overlay)
    const rate = (1 / duration) * 10
    const fadeInCallback = () => {
      mat.opacity -= rate
      if (mat.opacity <= 0.01) {
        removeEffect()
        res(true)
      }
    }
    const removeEffect = addAfterEffect(fadeInCallback)
  })
}
export default fadeIn